import { useState } from 'react';
import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import PartnersGallery from './components/PartnersGallery';
import ReviewSection from '../../components/reviews/ReviewSection';

// Partner 타입 정의 추가
interface Partner {
  id: string;
  name: string;
  owner: string;
  description: string;
  specialties: string[];
  contact: string;
  location: string;
  image: string;
  icon: string;
}

export default function PartnersPage() {
  const [selectedPartner, setSelectedPartner] = useState<Partner | null>(null);
  const [selectedCategory, setSelectedCategory] = useState('all');

  return (
    <div className="min-h-screen bg-gradient-to-b from-emerald-50 to-white">
      <Header />
      
      <main className="pt-20 pb-16">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h1 className="text-4xl font-bold text-gray-900 mb-4">참여업체 소개</h1>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              고흥꿈트리 협동조합에 함께하는 7개 농가를 소개합니다. 
              각자의 전문 분야를 살려 치유와 힐링의 공간을 만들어가고 있습니다.
            </p>
          </div>

          <PartnersGallery 
            selectedCategory={selectedCategory}
            onCategoryChange={setSelectedCategory}
            onPartnerClick={setSelectedPartner}
          />
        </div>
      </main>

      {/* 업체 상세 모달 */}
      {selectedPartner && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl max-w-4xl max-h-[90vh] overflow-y-auto w-full">
            <div className="p-6 border-b">
              <div className="flex items-center justify-between">
                <div className="flex items-center space-x-4">
                  <div className="w-12 h-12 bg-emerald-100 rounded-full flex items-center justify-center">
                    <i className={`${selectedPartner.icon} text-emerald-600 text-xl`}></i>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-gray-900">{selectedPartner.name}</h2>
                    <p className="text-emerald-600 font-medium">{selectedPartner.owner}</p>
                  </div>
                </div>
                <button
                  onClick={() => setSelectedPartner(null)}
                  className="p-2 text-gray-500 hover:text-gray-700 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer"
                >
                  <i className="ri-close-line text-2xl"></i>
                </button>
              </div>
            </div>

            <div className="p-6">
              <div className="grid lg:grid-cols-2 gap-8">
                <div>
                  <img
                    src={selectedPartner.image}
                    alt={selectedPartner.name}
                    className="w-full h-64 object-cover rounded-lg mb-6"
                  />
                  
                  <div className="space-y-4">
                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">업체 소개</h3>
                      <p className="text-gray-600 leading-relaxed">{selectedPartner.description}</p>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">전문 분야</h3>
                      <div className="flex flex-wrap gap-2">
                        {selectedPartner.specialties.map((specialty, index) => (
                          <span
                            key={index}
                            className="px-3 py-1 bg-emerald-100 text-emerald-700 text-sm rounded-full"
                          >
                            {specialty}
                          </span>
                        ))}
                      </div>
                    </div>

                    <div>
                      <h3 className="text-lg font-semibold text-gray-900 mb-2">연락처</h3>
                      <div className="space-y-1">
                        <p className="text-gray-600">
                          <i className="ri-phone-line mr-2"></i>
                          {selectedPartner.contact}
                        </p>
                        <p className="text-gray-600">
                          <i className="ri-map-pin-line mr-2"></i>
                          {selectedPartner.location}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div>
                  {/* 리뷰 섹션 */}
                  <ReviewSection partnerId={selectedPartner.id} />
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
}
